import { render, staticRenderFns } from "./InfiniteLoading.vue?vue&type=template&id=af640f54"
import script from "./InfiniteLoading.vue?vue&type=script&lang=js"
export * from "./InfiniteLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports